// extracted by mini-css-extract-plugin
module.exports = {"toggle":"toggle__OreTr","icon":"icon__2X_oW","tooltip":"tooltip__2Qlqm"};